import React from 'react';
import {compose, mapProps} from 'recompose';
import gql from 'graphql-tag';
import {graphql} from 'react-apollo';
import {renderForError, renderWhileLoading} from 'App/util/recompose/graphql';
import GenderChartPublic from './GenderChartPublic';
import {process_country} from "../helper";


@compose(
  graphql(gql`
  query {
    generals_genders_distributions {
      count
      gender
    }
  }`,
    {name: 'general_gender'}),
  mapProps(
    (ownerProps) => ({
      ...ownerProps,
      data: {
        ...ownerProps.general_gender,
        error: ownerProps.general_gender.error,
        loading: ownerProps.general_gender.loading,
      }
    })
  ),
  renderWhileLoading(),
  renderForError(),
)

export default class Gender extends React.Component {
  render() {
    const extGender = process_country("gender");
    // general, transform it into an nice, reverse in order to display it in the right order
    const seriesGeneral = this.props.data.generals_genders_distributions.map(
      data => ({name: data.gender, data: [data.count + extGender[data.gender]]})
    );

    return (
            <GenderChartPublic data={this.props.data.generals_genders_distributions}
                         title="Gender Distribution of ESID"
                         categories={['Gender']}
                         series={seriesGeneral}/>
    );
  }
};



// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/Gender.js